<template>
    <div>
        <CRow>
            <CCol sm="12" xl="12">
                <CCard>
                    <CCardHeader>
                        <strong>Data Logs Details</strong>
                    </CCardHeader>
                    <CCardBody>
                        <pre style="text-align:left;direction:ltr;">{{data_log}}</pre>
                    </CCardBody>
                    <CCardFooter>
                        <CButton color="dark" @click="go_back">Back</CButton>
                    </CCardFooter>
                </CCard>
            </CCol>
        </CRow>
    </div>
</template>
<script>
export default {
    data () {
        return {
            data_log: [],
        }
    },
    mounted(){
        this.get();
    },
    methods: {
        get() {
            this.axios.get('arbitrage/data_source_logs/'
                + '?id=' + this.$route.params.id)
                .then(res => {
                    this.data_log = res.data[0].data_log;
                })
        },
        go_back(){
            this.$router.go(-1);
        }
    },
}
</script>
